export const cardPayComplTranInfo = {
  request: {
    header: {
      messageFunction: "TRNA",
    },
    completionAdvice: {
      environment: {
        acquirer: {
          identification: "00000000002",
        },
        merchant: {
          identification: "123456789123456",
          locationAndContact: {
            addressLine: ["Acme Traders Small Str"],
            townName: "Cape Town",
            countrySubDivision: ["WC"],
            countryCode: "ZA",
          },
        },
        pointOfInteraction: {
          identification: "ATS10101",
          capabilities: {
            pinLengthCapabilities: 12,
          },
        },
        card: {
          plainCardData: {
            pan: "493805******7383",
            expiryDate: "2022-05",
            cardSequenceNumber: "320",
          },
          serviceOption: "100",
        },
      },
      context: {
        cardPresent: true,
        cardHolderPresent: true,
        onlineContext: true,
        cardDataEntryMode: "CTLS",
      },
      transaction: {
        merchantCategoryCode: "1234",
        originalTransaction: {
          transactionIdentification: {
            transactionDateTime: "2022-08-18T13:01:48.000+00:00",
            transactionReference: "14c51077832f4ab486ff597e7c745620",
          },
          transactionType: "CRDP",
        },
        transactionIdentification: {
          transactionDateTime: "2022-08-18T13:01:48.625Z",
          transactionReference: "56b44880b4e8477393d030e44a2221e5",
        },
        transactionType: "CRDP",
        transactionDetails: {
          currency: "710",
          /* prettier-ignore */
          totalAmount: 160.00,
          accountType: "CHCK",
        },
      },
    },
  },
  response: {
    header: {
      messageFunction: "TRNR",
    },
    completionAdviceResponse: {
      environment: {
        acquirer: null,
        merchant: {
          identification: "123456789123456",
          locationAndContact: {
            addressLine: ["Acme Traders Small Str "],
            townName: "Cape Town    ",
            countrySubDivision: ["WC"],
            countryCode: "ZA",
          },
        },
        pointOfInteraction: {
          identification: "ATS10101",
          capabilities: {
            pinLengthCapabilities: 12,
          },
        },
        card: {
          plainCardData: {
            pan: "493805******7383",
            expiryDate: "2022-05",
            cardSequenceNumber: null,
            track1Data: null,
            track2Data: null,
            cardholderName: null,
          },
          maskedPan: null,
          serviceOption: null,
        },
        paymentToken: null,
        cardholder: null,
        posDataCode: null,
      },
      transaction: {
        transactionIdentification: {
          transactionDateTime: "2022-08-18T13:01:48.000+00:00",
          transactionReference: "56b44880b4e8477393d030e44a2221e5",
        },
        response: "APPR",
      },
      supplementaryData: null,
    },
  },
};
